__turbopack_context__.v({
  "className": "inter_4c7975d8-module__6WhEjW__className",
  "variable": "inter_4c7975d8-module__6WhEjW__variable",
});
